import { render, staticRenderFns } from "./ProposalEditor.vue?vue&type=template&id=2ae14065&scoped=true"
import script from "./ProposalEditor.vue?vue&type=script&lang=ts"
export * from "./ProposalEditor.vue?vue&type=script&lang=ts"
import style0 from "./ProposalEditor.vue?vue&type=style&index=0&id=2ae14065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae14065",
  null
  
)

export default component.exports